export default __webpack_public_path__ + "static/media/registration.b553d761.jpg";